var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(8 3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.44214101 0v9.95094216c5.99809749-4.3641327 8.99714619-3.6732554 8.99714619 2.07263194 0 5.2668367-2.9990487 9.2055182-8.99714619 11.8160447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 3.0975008h12.7110403"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturn);
export default __webpack_public_path__ + "static/media/saturn.279d50391ee1cbd3544f355b2ba12107.svg";
export { ForwardRef as ReactComponent };